module.exports = {"brands":["VISA_ELECTRON","VISA_DEBIT","MASTERCARD_DEBIT","MAESTRO"]}